import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useGetMany, useRecordContext } from 'react-admin';
import { Typography } from '@mui/material';

export const ServiceCompanyNamesField = ({ source = 'serviceCompanyIds' }) => {
    const record = useRecordContext();
    const serviceCompanyIds = useMemo(() => {
        const ids = record?.[source];
        return Array.isArray(ids) ? ids.filter(Boolean) : [];
    }, [record, source]);
    const { data: serviceCompanies = [], isPending } = useGetMany('service-company', { ids: serviceCompanyIds }, { enabled: serviceCompanyIds.length > 0 });

    const namesById = useMemo(() => {
        const byId = new Map();
        (serviceCompanies || []).forEach(company => {
            if (company?.id != null && company.name) {
                byId.set(String(company.id), company.name);
            }
        });
        return byId;
    }, [serviceCompanies]);

    if (isPending && serviceCompanyIds.length > 0) {
        return (
            <Typography variant='body2' component='span'>
                —
            </Typography>
        );
    }

    const names = serviceCompanyIds.map(id => namesById.get(String(id))).filter(Boolean);

    return (
        <Typography variant='body2' component='span'>
            {names.length > 0 ? names.join(', ') : '—'}
        </Typography>
    );
};

ServiceCompanyNamesField.propTypes = {
    source: PropTypes.string,
};
